import { e as r } from "./index-f8317a8e.js";
function s(n = {}) {
  const o = {
    selectedConfiguration: {},
    configurations: [],
    listConfigurationsNextCursor: null,
    calendars: [],
    currentUser: null,
    action: null,
    additionalParticipants: [],
    hideEditorTabs: [],
    ...n
  }, e = r(o);
  function t() {
    e.set("selectedConfiguration", { ...n.selectedConfiguration });
  }
  return e.onChange("action", async (i) => {
    i || t();
  }), {
    ...e,
    resetSelectedConfiguration: t
  };
}
export {
  s as C
};
